// extracted by mini-css-extract-plugin
module.exports = {"delta_max":"deltamaxnew_delta_max__2hwea"};